// src/redux/parkingLotApi.js
import { apiSlice } from "./apiSlice";

export const parkingLotApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 차고지 상세조회
        getParkingLotById: build.query({
            query: (parkingLotId) => ({
                url: `/api/user/parking_lot/v1/${parkingLotId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 주차장 수정
        putParkingLot: build.mutation({
            query: ({ parkingLotId, body }) => ({
                url: `/api/user/parking_lot/v1/${parkingLotId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),
        // 주차장 삭제
        deleteParkingLot: build.mutation({
            query: (parkingLotId) => ({
                url: `/api/user/parking_lot/v1/${parkingLotId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
        // 주차장 리스트 조회
        getParkingLotList: build.query({
            query: (params) => ({
                url: "/api/user/parking_lot/v1",
                method: "get",
                headers: { token: true },
                params,
            }),
        }),
        // 주차장 등록
        postParkingLot: build.mutation({
            query: (body) => ({
                url: "/api/user/parking_lot/v1",
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),
    }),
});

export const {
    useGetParkingLotByIdQuery,
    usePutParkingLotMutation,
    useDeleteParkingLotMutation,
    useGetParkingLotListQuery,
    usePostParkingLotMutation,
} = parkingLotApi;
